<template>
    <div>
        <CButton color="info" @click="openModal()">Complete</CButton>
        <CModal
                add-content-classes="border-0 bg-grey"
                :no-close-on-backdrop="true"
                :centered="true"
                :show.sync="profileImage"
                size="sm"
                :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div></div>

            </template>
            <template #body-wrapper>
                <div class="completeContainer">
                    <div class="mainImageContainer">
                        <img class="mainImage" :src="selectIndexImage || images[0].url"/>
                    </div>
                    <p class="ml-4" style="font-weight: bold">PROFILE PICTURE</p>
                    <CRow class="ml-3 mr-3">
                        <CCol style="margin-left: 2%">
                            <CRow xl="3" class="addProfileImage">
                                <i class="fa fa-plus-circle" aria-hidden="true"
                                   style="filter: invert();margin-left: auto;margin-right: auto;margin-top: 36%"></i>
                            </CRow>
                        </CCol>
                        <CCol 
                            v-for="(item, index) in images.slice(0,3)" :key="index"
                        >
                            <CRow xl="3" class="accountImage" @click="changeCurrentImage(index)">   
                                <img :src="item.url || ''" class="accountImage"/>
                                <div v-if="item.selected" style="position:absolute; bottom: 0; right: 0; margin-bottom:-0.5rem; margin-right:0.2rem">
                                    <img 
                                        width="19x" height="19px"
                                        src="https://lh3.googleusercontent.com/proxy/sbOiizbmBLYI7bEapyUdPMqqoswKXtkvX6ctBWkpa7yR63JvHu1JeE_LNpXYBFhdVXQNFhQZyVN7ixhrZtdPaoXH1YnTLOMRqW255m35DfHs2PQJ17k4SrjqFz2fpJzv4Q"     
                                    />
                                </div>
                            </CRow>
                        </CCol>

                    </CRow>
                </div>
            </template>
            <template #footer-wrapper>
                <div/>
            </template>
        </CModal>
    </div>
</template>

<script>
    export default {
        name: "complete",
        data() {
            return {
                // default should be false
                profileImage: false,
                selectIndexImage: '',
                images: [
                    {
                        url: 'https://nongpets.com/wp-content/uploads/2019/07/Beagle.jpg',
                        selected: true
                    },
                    {
                        url: 'https://previews.123rf.com/images/sonsedskaya/sonsedskaya1906/sonsedskaya190600035/126327060-portrait-of-a-funny-raccoon-in-red-sunglasses-showing-a-rock-gesture.jpg',
                        selected: false
                    },
                    {
                        url: 'https://i.pinimg.com/originals/e3/4b/54/e34b54ad346522cc24741f0ece724272.jpg',
                        selected:false
                    },
                    {
                        url: 'https://nongpets.com/wp-content/uploads/2019/07/Beagle.jpg'
                    },
                    {
                        url: 'https://nongpets.com/wp-content/uploads/2019/07/Beagle.jpg'
                    },
                ]
            }
        },
        methods: {
            openModal() {
                this.profileImage = true
            },
            changeCurrentImage(index) {
                // alert(`click at ${index}`);
        
                let i ;
                for(i = 0; i< this.images.length; i++){
                    this.images[i].selected= false;
                }
                
                this.images[index].selected= true;
                this.selectIndexImage= this.images[index].url;
            }
        }
    }
</script>

<style scoped>
    
    .completeContainer {
        background-color: white;
        border-radius: 50px !important;
        padding-bottom: 1.75rem;
        align-self: center;
        width: 380px;
    }
    .mainImageContainer{
        height: 380px;
    }
    .mainImage {
        /*top: 0;*/
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
    }
/* 
    img {
        
    } */

    .addProfileImage {
        width: 80px;
        height: 80px;
        background-color: #EFEFEF;
        border-radius: 10px;
        /* margin-top: 8%; */
    }

    .accountImage {
        width: 80px;
        height: 80px;
        background-color: green;
        border-radius: 10px;
    }

    .accountImage:hover{
        cursor: pointer;
    }
</style>